export const join = (parts: string[], separator = "-") => parts.filter((part) => !!part).join(separator);
